import type { SVGProps } from 'react';
const SvgStarHalf = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
    <path
      fill="#e4e7eb"
      d="M13.781 4.474A.88.88 0 0 0 13.003 4v16.253l5.246 2.653c.29.148.643.12.909-.072a.87.87 0 0 0 .349-.84l-.92-5.78 4.159-4.138a.868.868 0 0 0-.483-1.471l-5.81-.919z"
    />
    <path d="M13.003 4a.88.88 0 0 0-.778.474L9.55 9.686l-5.813.918a.87.87 0 0 0-.483 1.471l4.158 4.14-.916 5.78a.87.87 0 0 0 .35.839c.265.191.614.22.908.072l5.25-2.653z" />
  </svg>
);
export default SvgStarHalf;
